import { FC } from 'react';
import { Button } from '../../../../../components/common';
import useModal from '../../../../../components/partials/Modal/useModal';
import { cn } from '../../../../../utils/helpers';
import { useRunCampaign } from '../../../../../service/hooks';

interface Props {
  id: string;
}

const StartCampaignModal: FC<Props> = ({ id }) => {
  const { mutate: runCampaign, isPending: runLoading } = useRunCampaign();
  const { hideModal } = useModal();

  return (
    <div className="bg-[#F7F7F7]">
      <div className="p-8">You are about to run a campaign.</div>
      <div className={cn('p-4', 'flex gap-2 justify-end', 'border-t border-gray')}>
        <Button
          onClick={hideModal}
          variant="secondary"
          className="border-warninng text-warning font-medium py-2 px-4"
          disabled={runLoading}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            runCampaign(id);
          }}
          className="bg-positive text-raisin-black py-2 px-4 font-medium disabled:bg-gray"
          disabled={runLoading}
          isLoading={runLoading}
        >
          Proceed
        </Button>
      </div>
    </div>
  );
};

export default StartCampaignModal;
